import React from 'react';
import { motion } from 'framer-motion';
export function Solution() {
  return <section id="solution" className="py-24 bg-stone-900 text-stone-50" data-id="element-1193">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1194">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-1195">
          <p className="font-mono text-xs uppercase tracking-widest text-stone-400 mb-6" data-id="element-1196">
            The Solution
          </p>

          <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-[1.1] text-stone-50 mb-6 max-w-3xl" data-id="element-1197">
            From email chaos to instant infrastructure
          </h2>

          <p className="text-lg text-stone-400 leading-relaxed mb-16 max-w-2xl" data-id="element-1198">
            BlockQuote replaces the entire manual quoting workflow with
            real-time infrastructure. What took days now takes seconds.
          </p>

          {/* Workflow Diagram */}
          <div className="border border-stone-700" data-id="element-1199">
            {/* Header */}
            <div className="grid grid-cols-2 border-b border-stone-700" data-id="element-1200">
              <div className="p-4 border-r border-stone-700" data-id="element-1201">
                <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-1202">
                  Before: Manual Process
                </p>
              </div>
              <div className="p-4" data-id="element-1203">
                <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-1204">
                  After: BlockQuote
                </p>
              </div>
            </div>

            {/* Step 1 */}
            <div className="grid grid-cols-2 border-b border-stone-700" data-id="element-1205">
              <div className="p-6 border-r border-stone-700" data-id="element-1206">
                <div className="flex items-start gap-4" data-id="element-1207">
                  <span className="font-mono text-xs text-stone-500 mt-1" data-id="element-1208">
                    01
                  </span>
                  <div data-id="element-1209">
                    <p className="text-stone-300 font-medium mb-1" data-id="element-1210">
                      Email RFP received
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1211">
                      Unstructured data, manual parsing required
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1212">
                <div className="flex items-start gap-4" data-id="element-1213">
                  <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1214">
                    01
                  </span>
                  <div data-id="element-1215">
                    <p className="text-stone-50 font-medium mb-1" data-id="element-1216">
                      Instant quote request
                    </p>
                    <p className="text-sm text-stone-400" data-id="element-1217">
                      Structured input, real-time pricing
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="grid grid-cols-2 border-b border-stone-700" data-id="element-1218">
              <div className="p-6 border-r border-stone-700" data-id="element-1219">
                <div className="flex items-start gap-4" data-id="element-1220">
                  <span className="font-mono text-xs text-stone-500 mt-1" data-id="element-1221">
                    02
                  </span>
                  <div data-id="element-1222">
                    <p className="text-stone-300 font-medium mb-1" data-id="element-1223">
                      Manual pricing lookup
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1224">
                      Check PMS, spreadsheets, rate cards
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1225">
                <div className="flex items-start gap-4" data-id="element-1226">
                  <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1227">
                    02
                  </span>
                  <div data-id="element-1228">
                    <p className="text-stone-50 font-medium mb-1" data-id="element-1229">
                      Auto-generated packages
                    </p>
                    <p className="text-sm text-stone-400" data-id="element-1230">
                      Good / Better / Best within policy
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="grid grid-cols-2 border-b border-stone-700" data-id="element-1231">
              <div className="p-6 border-r border-stone-700" data-id="element-1232">
                <div className="flex items-start gap-4" data-id="element-1233">
                  <span className="font-mono text-xs text-stone-500 mt-1" data-id="element-1234">
                    03
                  </span>
                  <div data-id="element-1235">
                    <p className="text-stone-300 font-medium mb-1" data-id="element-1236">
                      48–72 hour response
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1237">
                      Back-and-forth negotiation via email
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1238">
                <div className="flex items-start gap-4" data-id="element-1239">
                  <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1240">
                    03
                  </span>
                  <div data-id="element-1241">
                    <p className="text-stone-50 font-medium mb-1" data-id="element-1242">
                      Instant hold + proposal
                    </p>
                    <p className="text-sm text-stone-400" data-id="element-1243">
                      Inventory secured, terms standardized
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 4 */}
            <div className="grid grid-cols-2" data-id="element-1244">
              <div className="p-6 border-r border-stone-700" data-id="element-1245">
                <div className="flex items-start gap-4" data-id="element-1246">
                  <span className="font-mono text-xs text-stone-500 mt-1" data-id="element-1247">
                    04
                  </span>
                  <div data-id="element-1248">
                    <p className="text-stone-300 font-medium mb-1" data-id="element-1249">
                      Lost groups + leakage
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-1250">
                      No audit trail, margin captured by wholesalers
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1251">
                <div className="flex items-start gap-4" data-id="element-1252">
                  <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1253">
                    04
                  </span>
                  <div data-id="element-1254">
                    <p className="text-stone-50 font-medium mb-1" data-id="element-1255">
                      One-click contract
                    </p>
                    <p className="text-sm text-stone-400" data-id="element-1256">
                      Direct booking, full audit trail, zero leakage
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Summary row */}
            <div className="grid grid-cols-2 border-t border-stone-700" data-id="element-1257">
              <div className="p-6 border-r border-stone-700" data-id="element-1258">
                <p className="font-mono text-sm text-stone-500" data-id="element-1259">
                  Result:{' '}
                  <span className="text-stone-300" data-id="element-1260">
                    Days of delay, margin loss
                  </span>
                </p>
              </div>
              <div className="p-6 bg-stone-800/50" data-id="element-1261">
                <p className="font-mono text-sm text-stone-400" data-id="element-1262">
                  Result:{' '}
                  <span className="text-red-600" data-id="element-1263">
                    Seconds to quote, direct revenue
                  </span>
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}